import type { LucideIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { cn } from '@/helpers/utils';

type ModeTileTone = 'primary' | 'gold' | 'competitive';

type ModeTileProps = {
  icon: LucideIcon;
  title: string;
  hint: string;
  tone: ModeTileTone;
};

const toneClasses: Record<ModeTileTone, string> = {
  primary: 'bg-primary/10 text-primary border-primary/20',
  gold: 'bg-gold/10 text-gold border-gold/30',
  competitive: 'bg-competitive-blue/10 text-competitive-blue border-competitive-blue/30',
};

export function ModeTile({ icon: Icon, title, hint, tone }: ModeTileProps): ReactElement {
  return (
    <div
      className={cn(
        'min-w-0 rounded-xl border px-1.5 py-3 sm:p-4 flex flex-col items-center gap-1 sm:gap-1.5 shadow-sm',
        toneClasses[tone],
      )}
    >
      <Icon className="h-5 w-5 sm:h-6 sm:w-6 shrink-0" />
      <div className="max-w-full text-[10px] sm:text-xs font-semibold text-foreground text-center whitespace-nowrap truncate">
        {title}
      </div>
      <div className="text-[9px] sm:text-[10px] leading-tight text-muted-foreground text-center">{hint}</div>
    </div>
  );
}
